<template>
  <div class="my-reply-box">
    <div class="limit show-flex-box-c">
      <div class="go-back show-flex-box-r">
        <span></span>
        <strong v-if="forumKinds == 'teacherForum'" @click="tabToInsForum">机构论坛</strong>
        <strong v-if="forumKinds == 'forum'" @click="tabToForum">官方公告首页</strong>
      </div>
      <div class="my-reply-bottom show-flex-box-r">
        <div class="classification-list">
          <ul class="show-flex-box-c" v-if= "forumBySelfList.length != 0">
            <li class="show-flex-box-r" v-for= "(item,index) in forumBySelfList" :key= "index" v-if= "forumBySelfList">
              <forumList v-if= "forumKinds == 'forum'" :listInfo = 'item'></forumList>
              <forumList v-if= "forumKinds == 'teacherForum'" :postTeacherForumList = 'item'></forumList>
            </li>
          </ul>
          <span class="place-holder" v-if= "forumBySelfList.length == 0">您暂时还没有回复哦~</span>
        </div>
        <forumHanlenav :myReplyClass= 'myReplyClass' :forumKinds= 'forumKinds'></forumHanlenav>
      </div>
    </div>
  </div>
</template>

<script>
import forumList from '@/components/forum/forum_list_cpn'
import forumHanlenav from '@/components/forum/forum_hanlenav_cpn'  //右侧导航
export default {
  name: 'my_reply',
  data () {
    return {
      forumKinds: '',
      forumBySelfList: false
    }
  },
  components:{
    forumHanlenav,
    forumList
  },
  created() {
    this.forumKinds = this.$route.params.type;
    this.myReplyClass = this.$route.query.myReplyClass;
  },
  methods:{
    tabToInsForum: function() {
      let toWhere = '/mars_box_ins/ins_entrance/ins_teacher_home/teacherForum/teacherForum';
      this.$router.push({'path':toWhere});
    },
    tabToForum: function() {
      let toWhere = '/forum/forum_home/forum';
      this.$router.push({'path':toWhere});
    },
    getForumBySelfList: function() {
      //this.$loading({fullscreen: true,background: 'rgba(0,0,0,0.5)',lock: true,text: '拼命加载中...'})；
      var test = {
        'page' : this.page,
        'limit' : 10,
        'resource': 'reply_by_self'
      };
      if (this.forumKinds == 'forum') {
        this.$client.getForumBySelfList(test)
        .then((res) => {
          this.forumBySelfList = res.data.list;
          // this.$loading().close();
        }).catch((err) => {
          // this.$loading().close();
          if (err.message) {
            this.$elementMsg.error({
              'message': err.message,
              'showClose':true,
              'customClass': 'pop-class-error',
              'duration': 3000
            });
          } else {
            this.$elementMsg.error({
              'message': '网络错误，请稍后重试',
              'showClose':true,
              'customClass': 'pop-class-error',
              'duration': 3000
            });
          }
        })
      } else if (this.forumKinds == 'teacherForum') {
        this.$client.getTeacherForumBySelfList(test)
        .then((res) => {
          this.forumBySelfList = res.data.list;
          // this.$loading().close();
        }).catch((err) => {
          // this.$loading().close();
          if (err.message) {
            this.$elementMsg.error({
              'message': err.message,
              'showClose':true,
              'customClass': 'pop-class-error',
              'duration': 3000
            });
          } else {
            this.$elementMsg.error({
              'message': '网络错误，请稍后重试',
              'showClose':true,
              'customClass': 'pop-class-error',
              'duration': 3000
            });
          }
        })
      }
    }
  },
  mounted(){
    this.getForumBySelfList();
  }
}
</script>

<style lang="less" scoped>
.my-reply-box{
  width: 100%;
  height: 100%;
  background: #f8f8f8;
  .limit{
    display: flex;
    width: 1200px;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding-top: 80px;
    padding-bottom: 40px;
    .go-back{
      display: flex;
      align-items: center;
      span{
        display: block;
        width: 6px;
        height: 12px;
        background: url('../../assets/forum/go_back_icon.png') no-repeat center center;
        background-size: 6px 12px;
        margin-right: 9px;
      }
      strong{
        display: block;
        font-size: 14px;
        font-weight: 400;
        color: #999;
        text-align: center;
        line-height: 13px;
        cursor: pointer;
      }
    }
    .my-reply-bottom{
      display: flex;
      justify-content: space-between;
      padding-top: 20px;
      .classification-list{
        width: 850px;
        border-radius: 10px;
        padding-left: 25px;
        padding-right: 20px;
        ul{
          display: flex;
          border-radius: 10px;
          background: #fff;
          li{
            padding-left: 25px;
            padding-right: 20px;
            overflow: hidden;
            display: flex;
            align-items: center;
            height: 119px;
            border-bottom: 1px solid #f5f5f5;  
          }
          li:hover{
            background: #fbfbfb;
          }
        }
        .place-holder{
          display: block;
          width: 870px;
          height: 200px;
          font-size: 20px;
          font-weight: 400;
          color: #999;
          line-height: 200px;
          text-align: center;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/ins_entrance/my_reply.vue